export default {
	methods: {
		buscarLookup() {
			return new Promise((resolve, reject) => {
				this.$http.get("api/contaCorrente/contaCapital/buscarLookup")
					.then((response) => {
						resolve(response.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		buscarHeader(nrmatricula) {
			return new Promise((resolve, reject) => {
				this.$http.get("api/contaCorrente/contaCapital/buscarHeader/"+nrmatricula)
					.then((response) => {
						resolve(response.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
    buscarSaldo(nrmatricula, page = 1, perPage = 10) {
      return new Promise((resolve, reject) => {
        this.$http
          .get(`api/contaCorrente/contaCapital/buscarSaldo/${nrmatricula}`, {
            params: {
              page: page,
              per_page: perPage
            }
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
		buscarGrafico(nrmatricula) {
			return new Promise((resolve, reject) => {
				this.$http.get("api/contaCorrente/contaCapital/buscarGrafico/"+nrmatricula)
					.then((response) => {
						resolve(response.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		buscarMemoriaCalculo(ano, nrmatricula) {
			return new Promise((resolve, reject) => {
				this.$http.get("api/contaCorrente/contaCapital/buscarMemoriaDeCalculo/"+nrmatricula+"/"+ano)
					.then((response) => {
						resolve(response.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		buscarFechamento(nrmatricula) {
			return new Promise((resolve, reject) => {
				this.$http.get("api/contaCorrente/contaCapital/buscarFechamento/"+nrmatricula)
					.then((response) => {
						resolve(response.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
	}
}
